export default {
      id: "ar_signalements-usage",
      viewBox: "0 0 140 100",
      url: "../dist/images/" + "sprite.svg#ar_signalements-usage",
      toString: function () {
        return this.url;
      }
    }